// Central role → access map. SINGLE SOURCE OF TRUTH.
// The backend enforces the same rules at the API layer — this map only controls the UI.
// If you add/rename a page, update this map. Sidebar + ProtectedRoute + landing redirect all read from it.

export const ROLES = ["admin", "hr", "sales", "employee"];

export const ROLE_LABEL = {
  admin: "Administrator",
  hr: "HR",
  sales: "Sales",
  employee: "Employee",
};

// path → array of roles allowed to view.
// Admin has universal access — do NOT list "admin" everywhere; we imply it via ADMIN_ALL_ACCESS.
export const PAGE_ROLES = {
  "/":            ["admin"],                        // Command Center (dashboard)
  "/leads":       ["admin", "sales"],
  "/clients":     ["admin", "sales"],
  "/proposals":   ["admin", "sales"],
  "/pipeline":    ["admin", "sales"],
  "/timeline":    ["admin", "sales"],
  "/schedule":    ["admin", "sales"],
  "/pricing":     ["admin", "sales"],
  "/catalog":     ["admin", "sales"],
  "/milestones":  ["admin", "sales"],
  "/insights":    ["admin"],
  "/backlog":     ["admin", "sales"],
  "/team":        ["admin"],
  "/talent":      ["admin", "hr"],
  "/talent-map":  ["admin", "hr"],
  "/roster":      ["admin", "hr"],
  "/field-techs": ["admin", "hr"],
  "/personnel":   ["admin", "hr"],
  "/site-access": ["admin", "hr"],
  "/leave":       ["admin", "hr"],
  "/timesheets":  ["admin", "employee"],
};

// Where each role lands after login (first accessible page).
export const ROLE_LANDING = {
  admin:    "/",
  hr:       "/personnel",
  sales:    "/pipeline",
  employee: "/timesheets",
};

export function canAccess(role, path) {
  const allowed = PAGE_ROLES[path];
  if (!allowed) return false;
  return allowed.includes(role);
}

export function landingFor(role) {
  return ROLE_LANDING[role] || "/login";
}
